import type { IRecording } from '../types/Recording';

/** Genre tags that should never be auto-transcribed or listed for transcription. */
export const NON_TRANSCRIPTION_GENRE_TAGS = [
  'Music',
  'Sound Art',
  'Field Notes',
  'Field Recording',
] as const;

export type TranscriptionExclusionReason = 'non-english';

const NON_TRANSCRIPTION_GENRE_TAG_SET = new Set(
  NON_TRANSCRIPTION_GENRE_TAGS.map((tag) => tag.toLowerCase())
);

export function getRecordingGenreTags(recording: Pick<IRecording, 'tags'>): string[] {
  return recording.tags?.genreTags ?? [];
}

export function hasNonTranscriptionGenreTag(genreTags: string[]): boolean {
  return genreTags.some((tag) => NON_TRANSCRIPTION_GENRE_TAG_SET.has(tag.toLowerCase().trim()));
}

export function isExcludedFromTranscription(
  recording: Pick<IRecording, 'tags' | 'transcriptionExcludedReason'>
): boolean {
  if (recording.transcriptionExcludedReason) {
    return true;
  }

  return hasNonTranscriptionGenreTag(getRecordingGenreTags(recording));
}
